import React from 'react'
import AppLayout from './AppLayout'
import { NavLink } from 'react-router-dom'


function CRMLayout({children}) {
    return (
        
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-2'>
                        <div className="list-group">
                            <NavLink to={"/customer/list"} className="list-group-item list-group-item-action">Customer / Vendor</NavLink>
                            <NavLink to={"/grievance/dashboard"} className="list-group-item list-group-item-action">Complaints / Grievance </NavLink>
                            <NavLink to={"/lead/dashboard"} className="list-group-item list-group-item-action">Leads </NavLink>
                            <NavLink to={"/tender/dashboard"} className="list-group-item list-group-item-action">Tender</NavLink>
                            <NavLink to={"/proposal/list"} className="list-group-item list-group-item-action">Proposal / Quotation</NavLink>
                            <NavLink to={"/crm/terms-template"} className="list-group-item list-group-item-action">Terms Templates</NavLink>
                            <NavLink to={"/crm/document-template"} className="list-group-item list-group-item-action">Documents</NavLink>
                        </div>
                    </div>
                    <div className='col-md-10'>
                        {children}
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default CRMLayout